module.exports = __webpack_public_path__ + "img/aiIcon-translate.baa8b54a.svg";